// extracted by mini-css-extract-plugin
export default {"black":"#000","primary":"#49aada","orange":"GZCPzFKvyyg1RXPfXg4S","root":"TVVOWbhoh2IPGkNnVaoi","active":"jvo6VO_yd546yY9XeUsQ","icon":"L52uCR4vkBPtZBLYMF5G"};